import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { getMockViewingDocuments } from '../../../../../RentalPortalViewing'
import { VIEWING_DOCUMENTS_PAGE_SIZE } from '../../RentalPortalViewingProfileDocuments.constants'

export function useViewingProfileDocuments({ documentsReloadKey, viewingId }) {
  const [page, setPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoading, setLoading] = useState(true)

  const readIdRef = useRef(0)

  function loadDocuments() {
    readIdRef.current += 1

    const readId = readIdRef.current

    setLoading(true)

    getMockViewingDocuments({
      page,
      page_size: VIEWING_DOCUMENTS_PAGE_SIZE,
      viewing_id: viewingId,
    })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setResponse(data)
          setError(false)
          setPage(data.pagination.page)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setError(true)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoading(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (viewingId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- the in-flight flag flips when the read starts
      loadDocuments()
    }
  }, [documentsReloadKey, page, reloadKey, viewingId])

  function handleSetPagination(nextPagination) {
    setPage(nextPagination.page)
  }

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    handleRefresh,
    handleSetPagination,
    hasError,
    isInitiated,
    isLoading,
    items: response?.results?.objects ?? EMPTY_LIST,
    pagination: {
      count: response?.pagination?.total ?? 0,
      page,
      pageCount: response?.pagination?.page_count ?? 0,
      pageSize: VIEWING_DOCUMENTS_PAGE_SIZE,
    },
  }
}
